"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const reducer_1 = require("./reducer");
const types_1 = require("./types");
const getInitialState = () => ({
    hasRun: false,
    loading: true,
    err: null,
    data: null,
    onDoneValue: null
});
const useQuery = (query, { variables = {}, shouldRun = true, onDone, onError } = {}) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.networkReducer, getInitialState());
    const loading = !shouldRun ? false : state.loading;
    (0, react_1.useEffect)(() => {
        const exec = (query, variables) => __awaiter(void 0, void 0, void 0, function* () {
            dispatch({ type: types_1.QueryActionType.REQUEST_IN_FLIGHT });
            try {
                const result = yield query(variables);
                const onDoneValue = yield (onDone === null || onDone === void 0 ? void 0 : onDone(result));
                dispatch({ type: types_1.QueryActionType.REQUEST_SUCCESS, payload: { data: result, onDoneValue } });
            }
            catch (err) {
                yield (onError === null || onError === void 0 ? void 0 : onError(err));
                dispatch({ type: types_1.QueryActionType.REQUEST_FAILED, payload: err });
            }
        });
        if (shouldRun && !state.hasRun) {
            exec(query, variables);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldRun, query]);
    return Object.assign(Object.assign({}, state), { loading });
};
exports.default = useQuery;
